import {
  ColoringFlat,
  FlatLegendSolid,
  FlatLegendSolidSchema,
  FlatLegendTransparent,
  FlatLegendType,
} from '@/api/api';

interface ColoringFlatFormProps {
  coloring: ColoringFlat;
  onChange: (coloring: ColoringFlat) => void;
  disabled?: boolean;
}

export default function ColoringFlatForm({
  coloring,
  onChange,
  disabled,
}: ColoringFlatFormProps) {
  return (
    <div className="space-y-3 bg-blue-50 p-3 rounded">
      <div>
        <label className="text-xs font-medium mb-1 block">Color</label>
        <input
          type="color"
          value={coloring.color}
          onChange={(e) => onChange({ ...coloring, color: e.target.value })}
          disabled={disabled}
          className="w-full h-10 px-1 py-1 border rounded"
        />
      </div>

      <div>
        <label className="text-xs font-medium mb-2 block">Legend Type</label>
        <select
          value={coloring.legend.type}
          onChange={(e) => {
            const newLegendType = e.target.value as FlatLegendType;
            const newLegend =
              newLegendType === FlatLegendType.Flat
                ? { type: FlatLegendType.Flat, label: '' }
                : {
                    type: FlatLegendType.TransparencyScale,
                    minLabel: '',
                    maxLabel: '',
                  };
            onChange({
              ...coloring,
              legend: newLegend as FlatLegendSolid | FlatLegendTransparent,
            });
          }}
          disabled={disabled}
          className="w-full px-3 py-2 border rounded text-sm"
        >
          <option value={FlatLegendType.Flat}>Flat</option>
          <option value={FlatLegendType.TransparencyScale}>
            Transparency Scale
          </option>
        </select>
      </div>

      {coloring.legend.type === FlatLegendType.Flat ? (
        <div>
          <label className="text-xs font-medium mb-1 block">Label</label>
          <input
            type="text"
            value={coloring.legend.label}
            onChange={(e) =>
              onChange({
                ...coloring,
                legend: { type: FlatLegendType.Flat, label: e.target.value },
              })
            }
            disabled={disabled}
            className="w-full px-3 py-2 border rounded text-sm"
            placeholder="Legend label"
          />
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-2">
          <div>
            <label className="text-xs font-medium mb-1 block">Min Label</label>
            <input
              type="text"
              value={coloring.legend.minLabel}
              onChange={(e) =>
                onChange({
                  ...coloring,
                  legend: {
                    type: FlatLegendType.TransparencyScale,
                    minLabel: e.target.value,
                    maxLabel: (coloring.legend as FlatLegendTransparent)
                      .maxLabel,
                  },
                })
              }
              disabled={disabled}
              className="w-full px-3 py-2 border rounded text-sm"
              placeholder="Min"
            />
          </div>
          <div>
            <label className="text-xs font-medium mb-1 block">Max Label</label>
            <input
              type="text"
              value={coloring.legend.maxLabel}
              onChange={(e) =>
                onChange({
                  ...coloring,
                  legend: {
                    type: FlatLegendType.TransparencyScale,
                    minLabel: (coloring.legend as FlatLegendTransparent)
                      .minLabel,
                    maxLabel: e.target.value,
                  },
                })
              }
              disabled={disabled}
              className="w-full px-3 py-2 border rounded text-sm"
              placeholder="Max"
            />
          </div>
        </div>
      )}
    </div>
  );
}
